import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransaction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.75362 3.8144C5.65338 5.23564 3.5 8.36635 3.5 12C3.5 12.2862 3.51336 12.5692 3.53948 12.8486L10.6629 10.9399L8.75362 3.8144ZM11.6518 3.03945L13.6901 10.6464L13.7017 10.6898C13.7517 10.8755 13.8222 11.1374 13.8532 11.3776C13.8922 11.6803 13.9014 12.1591 13.6197 12.647C13.338 13.1349 12.9188 13.3664 12.6371 13.4839C12.4136 13.5772 12.1515 13.6471 11.9657 13.6967L11.9223 13.7083L4.31457 15.7467C5.73588 18.8468 8.86649 21 12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C12.214 3 11.931 3.01334 11.6518 3.03945Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.4294 4.27259C10.1785 3.33602 10.053 2.86773 9.62083 2.67286C9.18865 2.47799 8.80723 2.66782 8.04439 3.04748C7.47028 3.33321 6.92361 3.67419 6.41239 4.06647C5.37054 4.8659 4.49636 5.86272 3.83975 7C3.18314 8.13728 2.75696 9.39275 2.58555 10.6947C2.50144 11.3336 2.47948 11.9775 2.51909 12.6176C2.57171 13.4681 2.59803 13.8933 2.98288 14.1701C3.36773 14.447 3.83602 14.3215 4.77259 14.0706L10.5681 12.5176C11.4788 12.2736 11.9342 12.1516 12.1413 11.7929C12.3484 11.4342 12.2264 10.9788 11.9824 10.0681L10.4294 4.27259Z",
		fill: "currentColor"
	})]
});
export default SvgTransaction;
